$(document).ready(function() {
	$('.js-dropdown').each((index, item)=> {
		$(item).addClass('dropdown');

		const realSelect = $(item).find('select');
		$(realSelect).addClass('dropdown__select');

		const options = [];
		$(item).find('option').each((index, item)=> {
			options.push({
				index,
				value: item.value,
				text: item.innerText,
				selected: item.selected,
			 })
		});

		const pseudoSelect = {
			select: $('<div>', { 'class': 'dropdown__pseudo-select' }),
			title: $('<div>', { 'class': 'dropdown__pseudo-select-title' }),
			titleText: $('<span>', {}),
			list: $('<div>', { 'class': 'dropdown__pseudo-select-list' }),
		};

		options.forEach((option)=> {
			if (option.selected) $(pseudoSelect.titleText).text(option.text);

			const optionElement = $('<div>', {
				'class': option.selected
					? 'dropdown__pseudo-select-option dropdown__pseudo-select-option--selected'
					: 'dropdown__pseudo-select-option',
				'text': option.text,
				'data-value': option.value
			});

			$(optionElement).on('click', ()=> {
				const otherOptions = $(pseudoSelect.list).find('.dropdown__pseudo-select-option');
				$(otherOptions).each((index, item)=> $(item).removeClass('dropdown__pseudo-select-option--selected'));

				const selectedOption = $(pseudoSelect.list).find(`.dropdown__pseudo-select-option[data-value="${option.value}"]`);
				$(selectedOption).addClass('dropdown__pseudo-select-option--selected');

				$(pseudoSelect.titleText).text(option.text);

				$(realSelect).find('option').each((index, item)=> {
					if (item.value === option.value) $(item).attr('selected', true)
					else $(item).attr('selected', false)
				});

				$(pseudoSelect.list).removeClass('dropdown__pseudo-select-list--opened')

				$(realSelect).trigger('change');
			});

			$(pseudoSelect.list).append(optionElement);
		})

		$(pseudoSelect.title).append(pseudoSelect.titleText);
		$(pseudoSelect.select).append(pseudoSelect.title);
		$(pseudoSelect.select).append(pseudoSelect.list);

		$(pseudoSelect.title).on('click', ()=> {
			$(pseudoSelect.list).toggleClass('dropdown__pseudo-select-list--opened')
		})

		$(item).append(pseudoSelect.select);
	})
});
